<div #container>
  <nav mat-tab-nav-bar>
    <a mat-tab-link *ngFor="let header of (headers$|async); let i = index"
      [active]="i == selectedIndex"
      (click)="onHeaderClick(i)"
      class="tab-link">
      <div class='tab-link-content-wrapper tab-link-content-border-{{header.state}}'>
        {{ header.label }}

        <ng-container *ngIf="header.requiredFields">
          <div class="tab-link-badge tab-link-badge-error">
            <span>{{ header.requiredFields }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="header.nonRequiredFields">
          <div class="tab-link-badge tab-link-badge-default">
            <span>{{ header.nonRequiredFields }}</span>
          </div>
        </ng-container>

        <button 
          *ngIf="selectedIndex == i && header.activeButton"
          class="tab-link-button"
          type="button"
          (click)="header.activeButton.onClick()">
          {{ header.activeButton.label }}
        </button>
      </div>
    </a>
  </nav>
</div>